export const configuration = {
    serverBaseUrl: "https://futuresl.fawkesengineering.com/",
    clientBaseUrl: "https://futuresl.fawkesengineering.com/"
};
